export const colors = {
    primary: '#4b2b9b',
    primaryDark: '#2D1A5D',
    secondary: '#f35f22'
  };
  